<template>
  <div>
    <!--    <h1>style</h1>-->
    <local-style
      class="template-styles"
      :options="options"
      :container_id="ids.container_id"
      :rect_id="ids.rect_id"
      elementType="cxNavMenu"
      :styleImgs="request_prefix === 'bigScreen' ? styleImgs : styleImgsHome"
      ref="localStyleComponent"
    />
  </div>
</template>

<script>
import localStyle from "toolbarComponents/styles/local-style.vue"
export default {
  name: "navMenu-options-style",
  components: { localStyle },
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      styleImgs: [require("assets/images/leftMenu/navMenu/style1.png")],
      styleImgsHome: [require("assets/images/leftMenu/navMenu/style1.png")]
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    }
  },
  methods: {}
}
</script>

<style></style>
